<template>
  <component :is="isSMViewport ? 'div' : BasicScrollingWithGradient">
    <div
      ref="resultsListRef"
      class="results-list"
    >
      <results-card
        v-for="(office, key) in $props.results"
        :key="key"
        :active="isActive(office)"
        :auto-scroll="$props.autoScroll"
        :hover="isHover(office)"
        :office="office"
        :product="$props.product"
        @submit="$emit('submit')"
      />
      <template v-if="$props.results.length === 0">
        <basic-message
          class="results-list__message"
          severity="warning"
          :closeable="false"
          :content="getTranslation('messages.emptyResults.text')"
          :title-label="getTranslation('messages.emptyResults.title')"
        />
      </template>
    </div>
  </component>
</template>

<script setup>
  import { ref } from 'vue'

  import { BasicMessage, BasicScrollingWithGradient } from '@shared/components/Basic'

  import useBrowser from '@shared/hooks/useBrowser'
  import useMedicalOffice from '@shared/hooks/useMedicalOffice'
  import useMapSearch from '@shared/hooks/useMapSearch'

  import ResultsCard from '@shared/components/MedicalSearch/components/ResultsCard'

  // HOOKS
  const { isSMViewport } = useBrowser()
  const { getTranslation } = useMedicalOffice()
  const { hoveredId, selectedId } = useMapSearch()

  // INIT
  defineEmits(['close', 'submit'])
  defineProps({
    autoScroll: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => undefined,
    },
    results: {
      type: Array,
      default: () => [],
    },
  })

  // DATA
  const resultsListRef = ref(null)

  // METHODS
  function isActive(office) {
    return office.zsrNumber === selectedId.value
  }

  function isHover(office) {
    return office.zsrNumber === hoveredId.value
  }
</script>

<style scoped>
.results-list {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;

  .results-list__message {
    margin-top: var(--fixed-spacing-fix-04);

    &-empty {
      display: flex;
      flex-direction: column;
      font-weight: bold;

      &__link {
        padding-top: 5px;
        align-self: flex-end;
      }
    }
  }
}

:root .scrollable {
  scrollbar-width: 8px;
}
</style>
